import React, { useEffect, useState } from "react";
import { Dialog, Table } from "../../../../layout";
import { Box } from "@mui/material";
import { InputDate } from "../../../../controls";
import { subDays } from "date-fns";
import moment from "moment";
import { action, API, controller } from "../../../../api/api";
import { ToFormData, useFormatPrice } from "../../../../hooks/Method";
import ViewSale from "../../../Sell/SaleHistory/ViewSale/ViewSale";

const SaleHistory = ({ cstmr }) => {
  const formatPrice = useFormatPrice();
  const [loading, setLoading] = useState(false);
  const [txns, setTxns] = useState([]);
  const [viewData, setViewData] = useState({});
  const [viewSale, setViewSale] = useState(false);
  const [sortDate, setSortDate] = useState({
    fromDate: `01/01/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });

  useEffect(() => {
    if (sortDate && cstmr && cstmr.id) {
      setLoading(true);
      API(controller.CustomerTxn + action.GetAllByCustomer).post(
        ToFormData({
          customerId: cstmr.id,
          fromDate: new Date(sortDate.fromDate).toISOString(),
          endDate: new Date(sortDate.toDate).toISOString(),
        }),
        (res) => {
          if (res && res.status === 200 && res.result) setTxns([...res.result]);
          setLoading(false);
        }
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cstmr, sortDate]);

  const handleDate = (name, newVal) => {
    setSortDate((x) => ({ ...x, [name]: newVal }));
  };

  const HeaderComp = () => (
    <Box className="flex items-center w-[100%]">
      <InputDate
        variant="outlined"
        fullWidth
        size="small"
        name="fromDate"
        value={sortDate.fromDate}
        views={["day", "month", "year"]}
        openTo="day"
        minDate={new Date("01/01/2000")}
        maxDate={subDays(new Date(sortDate.toDate), 1)}
        onChange={(date) =>
          handleDate("fromDate", new Date(date).toLocaleDateString())
        }
      />
      <span className="ml-[10px] mr-[10px] text-[16px] text-gray-500">TO</span>
      <InputDate
        variant="outlined"
        fullWidth
        size="small"
        name="toDate"
        value={sortDate.toDate}
        minDate={moment(sortDate.fromDate, "MM/DD/YYYY").add(1, "days")}
        views={["day", "month", "year"]}
        openTo="day"
        onChange={(date) =>
          handleDate("toDate", new Date(date).toLocaleDateString())
        }
      />
    </Box>
  );

  const handleView = (val) => {
    setViewData(val);
    setViewSale(!viewSale);
  };

  return (
    <>
      {!loading ? (
        <Table
          ActionComp={() => <></>}
          HeaderComp={HeaderComp}
          tblHead={[
            { id: "trans", label: "Transaction" },
            { id: "receipt", label: "Receipt" },
            { id: "amount", label: "Amount" },
            { id: "balance", label: "Balance" },
          ]}
          tblData={txns.map((txn) => {
            return {
              ...txn,
              trans: (
                <div className="flex flex-col text-gray-500">
                  <span>
                    {txn.txnType} {txn.note && ` | ${txn.note}`}
                  </span>
                  <span className="text-[12px]">
                    {moment(txn.createDate).format("MMM D, YYYY, h:mm A")} |{" "}
                    {txn.sellType}
                  </span>
                </div>
              ),
              receipt: txn.sellId ? (
                <div className="flex gap-2">
                  <span>{txn.sellId}</span>
                  <button
                    onClick={() => handleView(txn)}
                    className="text-blue-500 cursor-pointer hover:underline"
                  >
                    View Sale
                  </button>
                </div>
              ) : (
                ""
              ),
              amount:
                txn.txnType === "Payment" ? (
                  <span className="text-green-500">
                    {formatPrice(txn.amount)}
                  </span>
                ) : (
                  <span className="text-red-500">
                    {"(-) " + formatPrice(txn.amount)}
                  </span>
                ),
              balance:
                txn.balance >= 0 ? (
                  <span className="text-green-500">
                    {formatPrice(txn.balance)}
                  </span>
                ) : (
                  <span className="text-red-500">
                    {"(-) " + formatPrice(txn.balance)}
                  </span>
                ),
            };
          })}
        />
      ) : (
        <span className="p-[20px] text-[20px] font-medium text-gray-500 ">
          Loading...
        </span>
      )}

      {viewData && (
        <Dialog show={viewSale} onClose={false} maxWidth="md">
          <ViewSale
            {...{ id: viewData.sellId, setShowForm: setViewSale, handleView }}
          />
        </Dialog>
      )}
    </>
  );
};

export default SaleHistory;
